// Implementation-fee keeper: the resolved-row narrowing.
//
// The report row is ONE wire shape with five fields that are null together —
// the invariant is cross-field, not structural, which is exactly what a JSON
// Schema cannot say. The document therefore declares them all nullable, and
// this pair puts the guarantee back: `isResolvedImplementationFeeRow` is the
// runtime check, `ResolvedImplementationFeeRow` is what it narrows to, and a
// caller past the check reads five numbers with no `?? 0` standing in for a
// figure the report already computed.
//
// The five are re-checked rather than trusted from `unresolved_reason` alone.
// The server computes all six from one expression so they cannot disagree, but
// the failure mode of trusting the label would be a `number` that is null at
// runtime.
export function isResolvedImplementationFeeRow(row) {
    return (row.unresolved_reason === null &&
        row.suggested_gross_minor !== null &&
        row.suggested_our_share_minor !== null &&
        row.impl_split_pct !== null &&
        row.variance_minor !== null);
}
//# sourceMappingURL=implementationFee.js.map